import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

/**
 * Emergent Google Auth callback. Lands at /auth/callback#session_id=...
 * Exchanges session_id → session_token via backend, then navigates home.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const { completeGoogle } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      toast.error("Missing session in callback URL.");
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    completeGoogle(sessionId).then((res) => {
      // Clear URL fragment for tidiness
      window.history.replaceState(null, "", window.location.pathname);
      if (res.ok) {
        toast.success(`Welcome, ${res.user?.name || res.user?.email}.`);
        navigate("/", { replace: true });
      } else {
        toast.error(res.error || "Google sign-in failed.");
        navigate("/login", { replace: true });
      }
    });
  }, [completeGoogle, navigate]);

  return (
    <div className="min-h-screen ledger-paper flex items-center justify-center" data-testid="auth-callback">
      <p className="font-mono-ledger text-xs text-[#5C5F58] uppercase tracking-[0.25em]">
        Signing you in…
      </p>
    </div>
  );
}
